import { CKEditor } from "@ckeditor/ckeditor5-react";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router";
import { Alert, Snackbar } from "@mui/material";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

import "./About.css";
import Loader from "../../../components/Loading/Loader";
import AdminLayout from "../../../components/AdminLayout";
import {
  getagreement,
  updateagreement,
} from "../../../components/funtionsBD/Mainservice";

const Terms = () => {
  const [open, setOpen] = useState(false);
  const [open2, setOpen2] = useState(false);
  const [error, seterror] = useState();
  const [success, setsuccess] = useState();
  const [data, setData] = useState({
    english_content: "",
    french_content: "",
    german_content: "",
    spanish_content: "",
  }); // Object to store all languages
  const [loading, setloading] = useState(true);
  const navigate = useNavigate();
  const token = localStorage.getItem("ntk");
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const lng = searchParams.get("lng");
  const { t } = useTranslation();

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };
  const handleClose2 = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen2(false);
  };

  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    getData();
  }, [lng]);

  const getData = async () => {
    try {
      const params = {
        agreementType: "terms_use_agreement", //agreement and terms_use_agreement
      };
      const response = await getagreement(params);
      setloading(false);
      setData({
        english_content: response.data.data.english_content,
        french_content: response.data.data.french_content,
        german_content: response.data.data.german_content,
        spanish_content: response.data.data.spanish_content,
      });
    } catch (error) {
      setloading(false);
      if (error.code === 401) {
        localStorage.clear();
        navigate("/");
      }
    }
  };

  const handlesave = async () => {
    try {
      const params = {
        agreementType: "terms_use_agreement",
        ...data,
      };

      const response = await updateagreement(params);
      setloading(false);
      setsuccess(response.data.message);
      setOpen2(true);
    } catch (error) {
      setloading(false);
      seterror(error.message);
      setOpen(true);
      if (error.code === 401) {
        localStorage.clear();
        navigate("/");
      }
    }
  };

  const handleEditorChange = (newData) => {
    // Dynamically update the content for the selected language
    setData((prevData) => ({
      ...prevData,
      [lng]: newData,
    }));
  };

  return (
    <>
      <AdminLayout>
        <div className="languageoptions">
          <li className={lng === "english_content" ? "active_profile" : ""}>
            <Link to="/Termsofuse_Agreement?lng=english_content">English</Link>
          </li>
          <li className={lng === "french_content" ? "active_profile" : ""}>
            <Link to="/Termsofuse_Agreement?lng=french_content">French</Link>
          </li>
          <li className={lng === "german_content" ? "active_profile" : ""}>
            <Link to="/Termsofuse_Agreement?lng=german_content">German</Link>
          </li>
          <li className={lng === "spanish_content" ? "active_profile" : ""}>
            <Link to="/Termsofuse_Agreement?lng=spanish_content">Italian</Link>
          </li>
        </div>
        <div className="doccontainer1">
          <div id="editor"></div>

          <h1 className="data_heading">{t("terms")} </h1>
          <CKEditor
            editor={ClassicEditor}
            data={data[lng]} // Display the content of the selected language
            onReady={(editor) => {
              console.log("Editor is ready to use!", editor);
            }}
            onChange={(event, editor) => {
              handleEditorChange(editor.getData());
            }}
          />

          <div
            className="view_button"
            onClick={() =>
              navigate("/View", {
                state: {
                  id: "3",
                },
              })
            }
          >
            <VisibilityIcon />
            {t("viewcontent")}{" "}
          </div>
          <button className="ckedit_button" onClick={handlesave}>
            {t("save")}
          </button>
          {loading && <Loader />}
          <Snackbar
            open={open2}
            autoHideDuration={6000}
            onClose={handleClose2}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "center",
            }}
          >
            <Alert variant="filled" severity="success">
              {success}
            </Alert>
          </Snackbar>
          <Snackbar
            open={open}
            autoHideDuration={4000}
            onClose={handleClose}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "center",
            }}
          >
            <Alert variant="filled" severity="error">
              {error}
            </Alert>
          </Snackbar>
        </div>
      </AdminLayout>
    </>
  );
};

export default Terms;
